export enum TotpCodeChannel {
  SMS = "SMS",
  EMAIL = "EMAIL",
}
